// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"225":"adc394eb9c68bc3a8844","427":"e37b49da78512d6ef2ae","966":"4c6132365a2ec3f69435"}[chunkId] + ".js";
};